import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

import {first} from "rxjs/operators";
import {BoiteLien} from "../../../../domain/boitelien/boitelien";
import {Result} from "../../../../domain/common/http/result";
import {environment} from "../../../../environments/environment";

/**
 * Service http boite lien
 *
 * @author Lionel Gimenez
 * @date 18/07/2025
 */
@Injectable({
    providedIn: "root",
})
export class BoiteLienHttpService {
    /**
     * Constructeur
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Sauvegarde de la BoiteLien
     */
    save(boiteLien: BoiteLien): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/BoiteLien/saveLien`,boiteLien).pipe(first());
    }

    /**
     * Suppression de la BoiteLien
     */
    delete(idLien: number): Observable<Result> {
        return this.http.delete<Result>(`${environment.baseUrl}/controller/BoiteLien/deleteLien/${idLien}`,{}).pipe(first());
    }
}